/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export class DynamicMenuEvents {
}
DynamicMenuEvents.DYNAMIC_MENU_CHANGED_EVENT = 'dell.sirius.dynamic-menu.menu-changed';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZHluYW1pYy1tZW51LWV2ZW50cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zaGFyZWQvZHluYW1pYy1tZW51L2R5bmFtaWMtbWVudS1ldmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxNQUFNLE9BQU8saUJBQWlCOztBQUNILDRDQUEwQixHQUFHLHVDQUF1QyxDQUFDIn0=